"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Text = _interopRequireDefault(require("../Text"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _FillInDetails = _interopRequireDefault(require("./FillInDetails.proptypes"));
var _constant = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable react/prop-types */

var PlaceholderContainer = _styledComponents.default.div.withConfig({
  displayName: "FillInDetails__PlaceholderContainer",
  componentId: "sc-1hh4g3o-0"
})(["flex:1;margin:", " 0;display:flex;"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.small;
});
var TextBox = _styledComponents.default.div.withConfig({
  displayName: "FillInDetails__TextBox",
  componentId: "sc-1hh4g3o-1"
})(["margin:", " 0;padding-right:", ";flex-direction:column;flex:1;display:flex;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.tiny;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.small;
});
var Box = _styledComponents.default.div.withConfig({
  displayName: "FillInDetails__Box",
  componentId: "sc-1hh4g3o-2"
})(["padding:0 ", ";border:1px solid;border-color:", ";display:flex;align-items:center;min-height:", ";border-radius:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.small;
}, function (_ref5) {
  var theme = _ref5.theme,
    colorSchema = _ref5.colorSchema;
  return theme.colors[colorSchema.borderColor];
}, _constant.MIN_HEIGHT, function (_ref6) {
  var theme = _ref6.theme;
  return theme.borderRadius.normal;
});
var RightContent = _styledComponents.default.div.withConfig({
  displayName: "FillInDetails__RightContent",
  componentId: "sc-1hh4g3o-3"
})(["display:flex;cursor:pointer;"]);
var customTextProps = {
  style: {
    display: 'block'
  }
};
var FillInDetails = function FillInDetails(_ref7) {
  var accessible = _ref7.accessible,
    customProperties = _ref7.customProperties,
    onClick = _ref7.onClick,
    onEdit = _ref7.onEdit,
    placeholder = _ref7.placeholder,
    prefix = _ref7.prefix,
    _ref7$content = _ref7.content,
    content = _ref7$content === void 0 ? {} : _ref7$content,
    theme = _ref7.theme,
    type = _ref7.type,
    translation = _ref7.translation;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var primary = content.primary,
    secondary = content.secondary;
  var colorSchema = _constant.ColorSchema[type];
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(Box, (0, _extends2.default)({}, customProperties, {
      tabIndex: tabIndex,
      onClick: onClick,
      colorSchema: colorSchema
    }), primary ? /*#__PURE__*/_react.default.createElement(TextBox, {
      className: "guest-desc"
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      className: "primary-text",
      color: "neutral",
      customProperties: customTextProps
    }, prefix && /*#__PURE__*/_react.default.createElement("strong", null, prefix, ":\xA0"), primary), secondary && /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      className: "secondary-text",
      color: "greyDark"
    }, secondary)) : /*#__PURE__*/_react.default.createElement(PlaceholderContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      color: "greyDark"
    }, prefix && /*#__PURE__*/_react.default.createElement("strong", null, prefix, ":\xA0"), placeholder)), /*#__PURE__*/_react.default.createElement(RightContent, {
      onClick: onEdit
    }, primary ? /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: accessible,
      className: "edit-button",
      type: "small",
      color: "primary",
      bold: true
    }, translation === null || translation === void 0 ? void 0 : translation.edit) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      color: colorSchema.iconColor,
      fontsize: "titleNormal",
      icon: "ChevronRightIcon"
    })));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
FillInDetails.propTypes = _FillInDetails.default.PropTypes;
FillInDetails.defaultProps = _FillInDetails.default.DefaultProps;
var _default = FillInDetails;
exports.default = _default;